import { Filter, KeywordsConfig } from '../types/podlet.js';
import { isEmpty } from '../utils.js';
import { preProcessParameters } from './pre-processing.js';
import { TypeTransformationUtils } from './type-transformation.js';

export function filterKeywords(
    filter: Filter | undefined,
    config: Partial<KeywordsConfig>,
) {
    if (isEmpty(filter) || isEmpty(config)) {
        return {};
    }

    const parameters = preProcessParameters(config.preProcessingMap, filter);

    return TypeTransformationUtils.generatePlainMap(
        config.keywordsMap,
        parameters,
        config.ruleMap,
        true,
    );
}

export function filterFeed(filter: Filter, config: Partial<KeywordsConfig>) {
    if (isEmpty(filter) || isEmpty(config)) {
        return {};
    }

    const parameters = preProcessParameters(config.preProcessingMap, filter);

    return TypeTransformationUtils.generatePlainMap(
        config.feedMap,
        parameters,
        config.ruleMap,
        false,
    );
}

export function filterFeedString(
    filter: Filter,
    config: Partial<KeywordsConfig>,
) {
    if (isEmpty(filter) || isEmpty(config)) {
        return '';
    }

    const parameters = preProcessParameters(config.preProcessingMap, filter);

    const feedList = TypeTransformationUtils.generateList(
        config.feedMap,
        parameters,
        config.ruleMap,
    );
    const feedString = TypeTransformationUtils.listToDelimitedString(
        feedList,
        ';',
        false,
    );
    return feedString.toString();
}
